import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  headerText: {
    fontWeight: 600,
    textAlign: "left",
  },
  subtitleText: {
    color: "#9A9A9A",
    textAlign: "left",
    marginRight: "35px",
    marginTop: "10px",
    marginBottom: "10px",
  },
}))

export default styles
